import React, { useCallback, useState } from 'react';
import AdminLayout, { AdminTab } from './components/AdminLayout';
import AdminOrders from './AdminOrders';
import AdminQuotes from './AdminQuotes';
import AdminProducts from './AdminProducts';
import AdminCategories from './AdminCategories';

const TAB_TITLES: Record<AdminTab, string> = {
  orders: 'Commandes',
  quotes: 'Devis',
  products: 'Produits',
  categories: 'Catégories',
};

interface Props { onLogout: () => void; }

const AdminDashboard: React.FC<Props> = ({ onLogout }) => {
  const [tab, setTab] = useState<AdminTab>('orders');
  const [counts, setCounts] = useState<Partial<Record<AdminTab, number>>>({});

  // Stable per-tab callbacks — an inline arrow function here would get a new
  // identity every render, which would retrigger each section's fetch effect
  // in a loop (their useCallback/useEffect chains depend on this prop).
  const onOrdersCount = useCallback((n: number) => setCounts((prev) => ({ ...prev, orders: n })), []);
  const onQuotesCount = useCallback((n: number) => setCounts((prev) => ({ ...prev, quotes: n })), []);
  const onProductsCount = useCallback((n: number) => setCounts((prev) => ({ ...prev, products: n })), []);
  const onCategoriesCount = useCallback((n: number) => setCounts((prev) => ({ ...prev, categories: n })), []);

  return (
    <AdminLayout tab={tab} onTabChange={setTab} onLogout={onLogout} counts={counts} title={TAB_TITLES[tab]}>
      {tab === 'orders' && <AdminOrders onLogout={onLogout} onCountChange={onOrdersCount} />}
      {tab === 'quotes' && <AdminQuotes onLogout={onLogout} onCountChange={onQuotesCount} />}
      {tab === 'products' && <AdminProducts onLogout={onLogout} onCountChange={onProductsCount} />}
      {tab === 'categories' && <AdminCategories onLogout={onLogout} onCountChange={onCategoriesCount} />}
    </AdminLayout>
  );
};

export default AdminDashboard;
